import React, { useState } from "react";

import UserList from "./UserList";

import FleetList from "./FleetList";

import AccountManagerList from "./AccountManagerList";

import { useBootstrap } from "./BootstrapProvider";

import { config } from "../config";

import "./Admin.css";

import ClientList from "./ClientList";

import AdminUserList from "./AdminUserList";

import RequestForFirmList from "./RequestForFirmList";

import BunkerPrices from "./BunkerPrices";
import Ports from "./Ports";

const Admin: React.FC = () => {
  const { isBootstrapped, error } = useBootstrap();
  const [selectedClientDomain, setSelectedClientDomain] = useState<
    string | null
  >(null);
  const { apiBaseUrl } = config;
  const [activeSection, setActiveSection] = useState<
    "general" | "bunker" | "ports"
  >("general");

  if (error) {
    return (
      <div className="admin-container">
        <div className="admin-error">{error}</div>
      </div>
    );
  }

  if (!isBootstrapped) {
    return null;
  }

  return (
    <div className="admin-container">
      <h2 className="admin-title">Admin</h2>

      {/* Section Toggle Buttons */}
      <div className="admin-section-buttons">
        <button
          className={`primary-button ${activeSection === "general" ? "active" : ""}`}
          onClick={() => setActiveSection("general")}
        >
          General
        </button>
        <button
          className={`primary-button ${activeSection === "bunker" ? "active" : ""}`}
          onClick={() => setActiveSection("bunker")}
        >
          Bunker Prices
        </button>
        <button
          className={`primary-button ${activeSection === "ports" ? "active" : ""}`}
          onClick={() => setActiveSection("ports")}
          style={{ marginLeft: 8 }}
        >
          Port Notes
        </button>
      </div>

      {activeSection === "general" && (
        <>
          <AdminUserList />
          <AccountManagerList />
          <hr />
          <br />
          <ClientList
            apiUrl={apiBaseUrl}
            selectedClientDomain={selectedClientDomain}
            setSelectedClientDomain={setSelectedClientDomain}
            enableAddClient={true}
          />

          {selectedClientDomain && (
            <>
              <UserList
                clientDomain={selectedClientDomain}
                enableAddUser={true}
              />
              <FleetList clientDomain={selectedClientDomain} />
              <RequestForFirmList
                apiUrl={apiBaseUrl}
                clientDomain={selectedClientDomain}
              />
            </>
          )}
        </>
      )}

      {activeSection === "bunker" && (
        <div style={{ marginTop: 40 }}>
          <BunkerPrices />
        </div>
      )}

      {activeSection === "ports" && (
        <div style={{ marginTop: 40 }}>
          <Ports />
        </div>
      )}
    </div>
  );
};

export default Admin;
